import './styles/index.scss'
import { setupIcons } from '@/notebook/components/icons/setupIcon'
import ActionButton from './components/ActionButton.vue'
import EchoEditor from './components/EchoEditor.vue'
import locale, { en } from './locales'

setupIcons()

export { en, locale }
export * from './extensions'
export type * from './type'
export { type Editor as EditorInstance } from '@tiptap/core'
export { useEditor } from '@tiptap/vue-3'
export { ActionButton, EchoEditor }
